import { BLACK_c, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 25rem;
  margin-bottom: 35rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 15rem;
    margin-bottom: 30rem;
  }
`;

export const TopBox = styled.div`
  display: flex;
  flex-direction: column;
  & > span {
    &:nth-child(1) {
      font-weight: 300;
      font-size: 1.8rem;
      line-height: 3.2rem;
      color: ${MAIN_GREEN};
    }
    &:nth-child(2) {
      margin-top: 0.8rem;
      font-weight: 700;
      font-size: 5.2rem;
      line-height: 9.2rem;
    }
    &:nth-child(3) {
      font-weight: 300;
      font-size: 2.2rem;
      line-height: 3.8rem;
      color: ${BLACK_c};
    }
    &:nth-child(4) {
      margin-top: 3rem;
      font-weight: 300;
      font-size: 1.6rem;
      line-height: 2.8rem;
      color: ${MAIN_GREEN};
      width: fit-content;
      border-bottom: 1px solid ${MAIN_GREEN};
      cursor: pointer;
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > span {
      &:nth-child(1) {
        font-size: 1.4rem;
        line-height: 2.4rem;
      }
      &:nth-child(2) {
        margin-top: 0.5rem;
        font-size: 3.2rem;
        line-height: 5.4rem;
      }
      &:nth-child(3) {
        width: 31rem;
        font-size: 1.8rem;
        line-height: 3.2rem;
      }
    }
  }
`;
export const BottomBox = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 6rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: column;
    gap: 6rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 38.7rem;
  & > div {
    height: 36rem;
    border: 1px solid #363636;
    background-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    & > img {
      width: 30rem;
      height: 30rem;
    }
  }
  & > span:nth-child(2) {
    margin-top: 2rem;
    font-weight: 700;
    font-size: 3.2rem;
    line-height: 5.4rem;
  }
  & > span:nth-child(3) {
    margin-top: 1rem;
    font-weight: 300;
    font-size: 2rem;
    line-height: 3.6rem;
    color: ${BLACK_c};
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100%;
    & > div {
      height: 26rem;
      & > img {
        width: 18rem;
        height: 18rem;
      }
    }
    & > span:nth-child(2) {
      margin-top: 1.5rem;
      font-size: 2.2rem;
      line-height: 3.8rem;
    }
    & > span:nth-child(3) {
      margin-top: 0.5rem;
      font-size: 1.6rem;
      line-height: 2.8rem;
    }
  }
`;
